import { IconMainMenuViews } from "@suse-o11y/icons";
import React from "react";
import { useSelector } from "react-redux";

import { selectViewSlug } from "../../../app/state/route/RouteSelectors";
import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { useActiveMainMenuExtensionGroup } from "../../../queries/mainmenu";
import { KUBERNETES_OVERVIEW_PATH, VIEWS_OVERVIEW_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

import { GroupViewsIndexBreadcrumb } from "./GroupViewsIndexBreadcrumb";

export const ViewsIndexBreadcrumb: React.FC = () => {
	const viewSlug = useSelector(selectViewSlug);
	const group = useActiveMainMenuExtensionGroup(viewSlug);

	const viewsOverviewLink = useNavigateToLink(VIEWS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});
	const k8sOverviewLink = useNavigateToLink(KUBERNETES_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (group == null) {
		return (
			<BreadcrumbLayout
				icon={<IconMainMenuViews className={BREADCRUMB_ICON_CLASS} />}
				label="Views"
				to={viewsOverviewLink}
			/>
		);
	}

	return <GroupViewsIndexBreadcrumb group={group} to={group.isKubernetes ? k8sOverviewLink : undefined} />;
};
